import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import pb from '../pocketbase';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await pb.collection('users').authWithPassword(username, password);
            navigate(from, { replace: true });
        } catch {
            setError('Identifiants incorrects.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.glow} />
            <div style={styles.card} className="fade-in-up">
                <div style={styles.logo}>🐿️</div>
                <h2 style={styles.title} className="tvs-title-gradient">Connexion</h2>
                <form onSubmit={handleSubmit} style={styles.form}>
                    <input
                        style={styles.input}
                        className="tvs-input"
                        type="text"
                        placeholder="Nom d'utilisateur"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        autoFocus
                        required
                    />
                    <input
                        style={styles.input}
                        className="tvs-input"
                        type="password"
                        placeholder="Mot de passe"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                    />
                    {error && <p style={styles.error}>{error}</p>}
                    <button style={styles.btn} className="tvs-btn-primary tvs-btn-lift" type="submit" disabled={loading}>
                        {loading ? 'Connexion…' : 'Se connecter'}
                    </button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        backgroundColor: '#0f0f0f',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
    },
    glow: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '480px',
        height: '480px',
        background: 'radial-gradient(circle, rgba(255,68,68,0.18) 0%, rgba(255,68,68,0) 70%)',
        animation: 'heroGlow 4s ease-in-out infinite',
        pointerEvents: 'none',
    },
    card: {
        backgroundColor: '#161616',
        border: '1px solid #333',
        borderRadius: '16px',
        padding: '40px',
        width: '100%',
        maxWidth: '360px',
        position: 'relative',
        boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
    },
    logo: {
        fontSize: '2.8rem',
        textAlign: 'center',
        marginBottom: '4px',
    },
    title: {
        color: 'white',
        textAlign: 'center',
        marginBottom: '28px',
        fontWeight: 600,
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
    },
    input: {
        backgroundColor: '#222',
        border: '1px solid #444',
        borderRadius: '8px',
        padding: '12px 14px',
        color: 'white',
        fontSize: '1rem',
        outline: 'none',
    },
    error: {
        color: '#f87171',
        fontSize: '0.85rem',
        margin: 0,
        textAlign: 'center',
    },
    btn: {
        backgroundColor: '#ff4444',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '12px',
        fontSize: '1rem',
        fontWeight: 600,
        cursor: 'pointer',
        marginTop: '4px',
    },
};

export default LoginPage;
